import { z } from "zod";
import { mediaSchema } from "../zod/mediaSchema.js";

export const imageBannerBlockSchema = z.object({
	image: mediaSchema,
	text: z.string().optional(),
});
